export const defaultSetData = {
  putonprice: {
    columns: [
        {
            "title": "投放渠道",
            "key": "platform"
        },{
            "title": "默认最高价(元)",
            "key": "default_price"
        },{
            "title": "重点加价投放(元)",
            "key": "main_price"
        },{
            "title": "PC:移动出价比例",
            "key": "ratio"
        }
    ],
    data: [
        {
          "platform": "百度搜索",
          "default_price": "3",
          "main_price": "3~10",
          "ratio": "1:1"
        },{
          "platform": "百度信息流",
          "default_price": "30.5",
          "main_price": "0.5~2",
          "ratio": ""
        },{
          "platform": "百度爱采购CPC",
          "default_price": "2",
          "main_price": "2~10",
          "ratio": ""
        },{
          "platform": "360搜索",
          "default_price": "2",
          "main_price": "2~5",
          "ratio": "1:1"
        },{
          "platform": "360超级排名",
          "default_price": "0元赠送",
          "main_price": "无需加价",
          "ratio": ""
        },{
          "platform": "搜狗搜索",
          "default_price": "2",
          "main_price": "2~5",
          "ratio": "1:0.6"
        },{
          "platform": "UC神马搜索",
          "default_price": "2",
          "main_price": "2~5",
          "ratio": ""
        },{
          "platform": "今日头条搜索",
          "default_price": "0.5",
          "main_price": "0.5~2",
          "ratio": ""
        },{
          "platform": "今日头条信息流",
          "default_price": "0.5",
          "main_price": "0.5~2",
          "ratio": ""
        }
      ]
  }
}


//////////////////
// WEBPACK FOOTER
// ../projectCore/src/components/show-table/src/data.js
// module id = null
// module chunks = 